import { apiDelete, apiGet, apiPut } from '../_common';

export default {
  list() {
    return apiGet('/magenta/fiscal/pis-cofins-credit-ncm').then(result => result.response);
  },
  // rate is a percentage, PIS and COFINS together
  save(ncm, rate) {
    return apiPut(`/magenta/fiscal/pis-cofins-credit-ncm/${encodeURIComponent(ncm)}`, { rate })
      .then(result => result.response);
  },
  remove(ncm) {
    return apiDelete(`/magenta/fiscal/pis-cofins-credit-ncm/${encodeURIComponent(ncm)}`);
  },
};
